<template>
	<div class="col-12 col-md-6 col-lg-4 d-flex">
		<div class="card news-card border-0 rounded-4 align-items-stretch w-100">
			<template v-if="true == useHardLink && showPictureTag">
				<a :href="model.link" class="ratio ratio-16x9 overflow-hidden position-relative w-100">
					<event-picture :image="model.images" :alt="model.title"
						:classes="['cover-img', 'card-img-top', 'rounded-top-4']"></event-picture>
					<div class="img-fade-gradient position-absolute h-100 w-100 z-1"></div>
				</a>
			</template>
			<div class="card-body d-flex flex-column justify-content-between">
				<div class="card-wrapper">
					<h3 class="card-title mb-2 h4" v-if="model.title">
						<template v-if="true == useHardLink">
							<a :href="model.link" v-html="model.title" class="nice-hover nice-bottom position-relative pb-2 d-block"></a>
						</template>
					</h3>
					<div class="post-excerpt mt-2">
						<template v-if="true == useHardLink && model.excerpt">
							<p v-html="model.excerpt"></p>
						</template>
					</div>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import EventPicture from '@/components/EventPicture.vue';

export default {
	name: 'EventCard',
	props: {
		model: Object
	},
	components: {
		EventPicture
	},
	emits: ['openSingleModal'],
	data() {
		return {
			useHardLink: ('hard' === process.env.VUE_APP_SINGLE_LINK_TYPE || false),
			useModalLink: ('modal' === process.env.VUE_APP_SINGLE_LINK_TYPE || false),
			isOpen: false,
			test: [
				{'id': 1, 'name': 'test1'},
				{'id': 2, 'name': 'test2'},
				{'id': 3, 'name': 'test3'}
			]
		}
	},
	computed: {
		showPictureTag() {
			if (this.model.images && Object.keys(this.model.images).length && this.model.images.full && this.model.images.full.url) {
				return true;
			}
			return false
		}
	},
	methods: {
		openModal(id) {
			this.$emit('openSingleModal', id)
		}
	}
}
</script>

<style scoped lang="scss">
.event-card {
	position: relative;
}
</style>
